<template>
  <div class="search-box font-30 fb-start-center">
    <div class="search-box-input item-flex-1 fb-start-center">
      <i class="iconfont">&#xe6fb;</i>
      <input
        class="item-flex-1"
        type="text"
        v-model="searchKey"
        :placeholder="placeholder"
        @focus="handlerFocus"
        @blur="handlerBlur"
        @input="handlerChangeSearchKey"
      />
    </div>
    <div
      v-show="computedIsShowCencel"
      class="search-cancel"
      @click="handlerToClearSearchKey"
    >
      <span>取消</span>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'commonSearchInputBox',
  components: {},
  props: {
    searchValue: '',
    placeholder: '',
    delay: {
      // search事件触发延时
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      searchKey: '',
      isFocus: false,
      timer: null
    }
  },
  computed: {
    computedIsShowCencel() {
      let _result = false

      if (this.searchKey || this.isFocus) {
        _result = true
      }
      return _result
    }
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.searchKey = this.searchValue
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    this.methodCleatTimer()
  },
  destroyed() {},
  methods: {
    handlerSearch() {
      this.$emit('search', this.searchKey)
    },
    handlerChangeSearchKey() {
      if (this.delay === 0) {
        this.$emit('search', this.searchKey)
        return
      }
      this.methodCleatTimer()
      this.timer = setTimeout(() => {
        this.$emit('search', this.searchKey)
        this.timer = null
      }, this.delay)
    },
    handlerFocus() {
      this.isFocus = true
      this.$emit('focus')
    },
    handlerBlur() {
      this.isFocus = false
      this.$emit('blur')
    },
    /**
     * 清除输入内容
     */
    handlerToClearSearchKey() {
      this.searchKey = ''
      this.$emit('cancal')
      this.$emit('search', this.searchKey)
    },
    /**
     * 清除定时器
     */
    methodCleatTimer() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-box {
  width: 100%;
  height: 1.333333rem;
  min-height: 1.333333rem;

  > .search-box-input {
    height: 0.96rem;
    padding: 0 0.32rem;
    border-radius: 99999px;
    background: rgba(#191f25, 0.08);

    > i {
      color: rgba(#191f25, 0.28);
      margin-right: 0.266666rem;
    }

    > input {
      width: 100%;
      background: none;

      &:focus {
        border: none;
        outline: none;
      }
    }
  }
  > .search-cancel {
    color: rgba(#3296fa, 1);
    margin-left: 0.213333rem;
  }
}
</style>
